Vendd.Scripts.load(function () {
    'use strict';

    var $wrapper = $('.x-couriercenter-track-trace'), $courierCenterForm = $('.x-couriercenter-form');

    if ($wrapper.length < 1)
        return;

    var wrapper = $wrapper;

    wrapper.loading = function (loading) {
        if (loading) {
            $wrapper.addClass('x-loading');
        } else {
            $wrapper.removeClass('x-loading');
        };
    };

    $courierCenterForm.on('click', '.js-submit-button', function (e) {
        e.preventDefault();
        e.stopPropagation();

        var voucher = $('input[name="voucherCode"]').val();

        var currentUri = new URI(location.href);
        location.href = currentUri.removeQuery("voucher").addQuery("voucher", voucher).toString();
    });
});